var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightMd = function SvgChevronRightMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14L15 21L8 28",
    stroke: "#33445E",
    strokeWidth: 3
  })));
};
export default SvgChevronRightMd;